// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar {
  width: 280px;
  height: 100vh;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding-left: 1rem;
  padding-right: 1rem;
}
#sidebar-chicory-logo__wrapper {
  position: relative;
  left: -18px;
  display: flex;
  align-items: center;
  margin-top: 20px;
}
#sidebar-chicory-logo {
  width: 150px;
}
#sidebar-links {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.sidebar-item {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}

.sidebar-item__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 55px;
    border-radius: 10px;
    padding-left: 5px;
    padding-right: 5px
  }

.sidebar-item__header:hover {
      background-color: #f5f7fa;
      cursor: pointer;
    }

.sidebar-item__header a {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }

.sidebar-item > a {
    text-decoration: none;
    color: black;
    width: 100%
  }

.sidebar-item > a:hover {
      background-color: #f5f7fa;
    }

.sidebar-item__header-left {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    grid-gap: 10px;
    gap: 10px;
  }

.sidebar-item__header-text {
    display: flex;
    flex-wrap: wrap;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5rem;
  }

.sidebar-item__drawer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    margin-left: 35px;
  }

#sidebar-user {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 30px;
  padding-top: 20px;
  border-top: 1px solid #eaecf0;
}

#sidebar-user__left-group {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

#sidebar-user__avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border: 1px solid #eaecf0;
    border-radius: 10px;
    margin-right: 9px;
  }

#sidebar-user__info-name {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 5px;
    color: #344054;
  }

#sidebar-user__info-email {
    font-size: 13px;
    font-weight: 100;
    color: #888888;
  }

#sidebar-user__logout {
    display: flex;
    cursor: pointer;
    align-self: flex-start
  }

#sidebar-user__logout path {
      stroke: #667085;
    }

@media (max-width: 990px) {
  #sidebar {
    width: 200px;
  }
  #sidebar-user__logout {
    width: 20px;
    height: 20px;
    padding-top: 4px;
    padding-left: 4px;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.pcss"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;AAkDb;;AAjDE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB;EAWF;;AAVE;MACE,yBAAyB;MACzB,eAAe;IACjB;;AACA;MACE,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;IACrB;;AAEF;IACE,qBAAqB;IACrB,YAAY;IACZ;EAIF;;AAHE;MACE,yBAAyB;IAC3B;;AAEF;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,cAAS;IAAT,SAAS;EACX;;AACA;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,iBAAiB;EACnB;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAqC/B;;AAnCE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;AAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;EACnB;;AACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;AACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;AACA;IACE,aAAa;IACb,eAAe;IACf;EAIF;;AAHE;MACE,eAAe;IACjB;;AAIJ;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;AACF","sourcesContent":["$midDesktop: 990px;\n\n#sidebar {\n  width: 280px;\n  height: 100vh;\n  background-color: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n#sidebar-chicory-logo__wrapper {\n  position: relative;\n  left: -18px;\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n}\n#sidebar-chicory-logo {\n  width: 150px;\n}\n#sidebar-links {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.sidebar-item {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    height: 55px;\n    border-radius: 10px;\n    padding-left: 5px;\n    padding-right: 5px;\n    &:hover {\n      background-color: #f5f7fa;\n      cursor: pointer;\n    }\n    & a {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n    }\n  }\n  & > a {\n    text-decoration: none;\n    color: black;\n    width: 100%;\n    &:hover {\n      background-color: #f5f7fa;\n    }\n  }\n  &__header-left {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 10px;\n  }\n  &__header-text {\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 1.5rem;\n  }\n\n  &__drawer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 50px;\n    margin-left: 35px;\n  }\n}\n\n#sidebar-user {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  margin-top: 30px;\n  margin-bottom: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #eaecf0;\n\n  &__left-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  &__avatar {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    border: 1px solid #eaecf0;\n    border-radius: 10px;\n    margin-right: 9px;\n  }\n  &__info-name {\n    font-size: 14px;\n    font-weight: 400;\n    margin-bottom: 5px;\n    color: #344054;\n  }\n  &__info-email {\n    font-size: 13px;\n    font-weight: 100;\n    color: #888888;\n  }\n  &__logout {\n    display: flex;\n    cursor: pointer;\n    align-self: flex-start;\n    & path {\n      stroke: #667085;\n    }\n  }\n}\n\n@media (max-width: $midDesktop) {\n  #sidebar {\n    width: 200px;\n  }\n  #sidebar-user__logout {\n    width: 20px;\n    height: 20px;\n    padding-top: 4px;\n    padding-left: 4px;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
